const actualATCPos = document.querySelector('.product-form__submit').offsetTop;
const alwaysSticky = document.querySelector('[data-sticky-add-to-cart]').dataset.stickyAddToCart;

const isInViewport = function(elem) {
  const distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const buildStickyATC = function() {
  const stickyCta = document.createElement('div');
  stickyCta.classList.add('ecg-sticky-atc');

  stickyCta.innerHTML = `<div class="atc-width">
    <div>
      <strong class="ecg-sticky-atc__title"></strong>
      <div class="ecg-sticky-atc__price"></div>
    </div>
    <div class="ecg-sticky-atc__add">
      <button class="button button--secondary ecg-sticky-add"></button>
    </div>
  </div>
  `;
  document.body.appendChild(stickyCta);

  document.querySelector('.ecg-sticky-atc__add button').textContent = document.querySelector('.product-form__submit').textContent;
};

const handleSubscription = () => {
  // Update price when selecting different purchase option
  setTimeout(function() {
    document.querySelector('.ecg-sticky-atc__price').innerHTML = document.querySelector('.ecg-info-wrap .price__container').innerHTML;
  }, 300);
};

if (actualATCPos) {
  buildStickyATC();
  if (alwaysSticky === 'true') {
    document.querySelector('.ecg-sticky-atc').classList.add('is--active');
    document.querySelector('.ecg-sticky-atc__price').innerHTML = document.querySelector('.ecg-info-wrap .price__container').innerHTML;
    document.querySelector('.ecg-sticky-atc__title').innerHTML = document.querySelector('h1').innerHTML;
  }
  document.addEventListener('scroll', event => {
    document.querySelector('.ecg-sticky-atc__price').innerHTML = document.querySelector('.ecg-info-wrap .price__container').innerHTML;
    document.querySelector('.ecg-sticky-atc__title').innerHTML = document.querySelector('h1').innerHTML;

    if (alwaysSticky === 'false') {
      if (
        !isInViewport(document.querySelector('.product-form__submit')) &&
        document.documentElement.scrollTop > actualATCPos
      ) {
        document.querySelector('.ecg-sticky-atc').classList.add('is--active');
      } else {
        document.querySelector('.ecg-sticky-atc').classList.remove('is--active');
      }
    }
  });

  const hasSubscription = document.querySelector('.shopify_subscriptions_app_block');
  if (hasSubscription) {
    hasSubscription.addEventListener('click', handleSubscription);
  }

  document.querySelector('.ecg-sticky-add').addEventListener('click', function() {
    document.querySelector('.product-form__submit').click();
  });
}
